import { Model } from 'core/models';
import { AppUser } from 'models/AppUser';
import { FileTemplate } from 'models/FileTemplate';
import { Menu } from 'models/Menu';
import { Site } from 'models/Site';
import { Moment } from 'moment';


export class MenuReport extends Model {
    public id?: number;
    public code?: string;
    public name?: string;
    public siteId?: number;
    public menuId?: number;
    public updatedAt?: Moment;
    public modifierId?: number;
    public site?: Site;
    public Menu?: Menu;
    public modifier?: AppUser;
    public fileTemplates?: FileTemplate[];
}
